"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileDrawer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const useDrawer_1 = require("../../../hooks/useDrawer/useDrawer");
const HamburgerIcon_1 = require("../../../assets/icons/HamburgerIcon");
const DrawerListItem_1 = require("../drawerListItem/DrawerListItem");
const Logout_1 = require("../../../pages/profile/profileActions/logout/Logout");
const Styled = __importStar(require("./MobileDrawer.styles"));
const MobileDrawer = ({ drawerRoutes, onClickRoute }) => {
    const { isDrawerOpen, setIsDrawerOpen } = (0, useDrawer_1.useDrawer)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.Container, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: () => setIsDrawerOpen(!isDrawerOpen), children: (0, jsx_runtime_1.jsx)(HamburgerIcon_1.HamburgerIcon, { isOpen: isDrawerOpen }) }) }), (0, jsx_runtime_1.jsxs)(Styled.MobileDrawer, { isDrawerOpen: isDrawerOpen, children: [drawerRoutes.map((route) => route.isVisible ? ((0, jsx_runtime_1.jsx)(DrawerListItem_1.DrawerListItem, { icon: route.icon, activeIcon: route.activeIcon, to: route.to, title: route.title, open: true, onClickRoute: () => {
                            setIsDrawerOpen(false);
                            onClickRoute && onClickRoute();
                        } }, route.to)) : null), (0, jsx_runtime_1.jsx)(Styled.LogoutWrapper, { children: (0, jsx_runtime_1.jsx)(Logout_1.Logout, {}) })] })] }));
};
exports.MobileDrawer = MobileDrawer;
